import { TranslationKeys } from "i18next";

export class Route {
    public slug: string;
    public index: number;
    public langKey: TranslationKeys;

    constructor(slug: string, index: number, title: TranslationKeys) {
        this.slug = slug;
        this.index = index;
        this.langKey = title;
    }
}

/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
    homePage: new Route('/', 0, 'sideNav.home'),
    customizationPage: new Route('/customization', 1, 'sideNav.modelCustomization'),
    allStructuresPage: new Route('/all-structures', 2,  'sideNav.allStructures'),
    modelSelectionPage: new Route('/selection', 3, 'sideNav.modelSelection'),
    daemonConfigPage: new Route('/daemon', 4, 'sideNav.daemonConfig'),
    dashboardPage: new Route('/dashboard', 5, 'sideNav.openDashboard'),
    textEditorPage: new Route('/text-editor', 6, 'sideNav.fileEditor'),
    licensePage: new Route('/license', 7, 'sideNav.license'),
    aboutPage: new Route('/about', 8, 'sideNav.about'),
};
